import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  nfcLandingPageTextAccent,
  nfcLandingPageTextAccentNowrap,
} from '../NfcLandingPageTranslationValues'

type NfcLandingPageHeroTitleOnlyTextProps = {
  className?: string
  shouldWrap?: boolean
}

export const NfcLandingPageHeroTitleOnlyText: FC<
  NfcLandingPageHeroTitleOnlyTextProps
> = ({ className, shouldWrap = true }) => {
  return (
    <h1
      className={clsx(
        'mt-4 text-center text-xl font-medium tablet:mt-0 tablet:text-left tablet:text-3xl',
        className,
      )}
    >
      <FormattedMessage
        id="nfc.hero.title"
        values={{
          highlight: shouldWrap
            ? nfcLandingPageTextAccentNowrap
            : nfcLandingPageTextAccent,
        }}
      />
    </h1>
  )
}
